import newApiManager from './NewAxiosInstance';

export interface NiceAuthUrlResponse {
  authUrl: string;
  transactionId: string;
  requestNo: string;
  key: string;
}

export interface NiceVerifiedData {
  name?: string;
  birthdate?: string;
  gender?: string;
  national_info?: string;
  mobile_co?: string;
  mobile_no?: string;
  ci?: string;
  di?: string;
  [key: string]: string | number | boolean | undefined;
}

export interface NiceResultResponse {
  success: boolean;
  message?: string;
  /** 로그인 회원 번호와 실명인증 번호 일치 여부 (false 면 다른 번호로 인증됨) */
  phoneMatched?: boolean;
  data?: NiceVerifiedData;
}

/** 휴대폰 본인확인 시작 - NICE 표준창 인증 URL 발급. memberId 를 넘기면 인증 완료 시 회원 인증상태가 저장된다. */
export const postNiceAuthUrl = async (memberId?: number): Promise<NiceAuthUrlResponse> => {
  const res = await newApiManager.post('/api/v1/security/nice/authurl', null, {
    params: memberId != null ? { memberId } : undefined,
  });
  return res.data;
};

/** 복호화된 본인확인 결과 조회 (1회용). */
export const getNiceResult = async (key: string): Promise<NiceResultResponse> => {
  const res = await newApiManager.get('/api/v1/security/nice/result', { params: { key } });
  return res.data;
};
